__turbopack_context__.v({
  "accordionSlideOverwrite": "breadcrumb-module-scss-module__pEVb_a__accordionSlideOverwrite",
  "breadcrumb": "breadcrumb-module-scss-module__pEVb_a__breadcrumb",
  "breadcrumbItem": "breadcrumb-module-scss-module__pEVb_a__breadcrumbItem",
  "breadcrumbSeparator": "breadcrumb-module-scss-module__pEVb_a__breadcrumbSeparator",
  "breadcrumbWrapper": "breadcrumb-module-scss-module__pEVb_a__breadcrumbWrapper",
  "fadeIn": "breadcrumb-module-scss-module__pEVb_a__fadeIn",
  "fadeOut": "breadcrumb-module-scss-module__pEVb_a__fadeOut",
  "scaleIn": "breadcrumb-module-scss-module__pEVb_a__scaleIn",
  "scaleOut": "breadcrumb-module-scss-module__pEVb_a__scaleOut",
  "zoomIn": "breadcrumb-module-scss-module__pEVb_a__zoomIn",
  "zoomOut": "breadcrumb-module-scss-module__pEVb_a__zoomOut",
});
